import { render } from "./BaseFnbSideNav.vue?vue&type=template&id=613821bd&scoped=true"
import script from "./BaseFnbSideNav.vue?vue&type=script&lang=js"
export * from "./BaseFnbSideNav.vue?vue&type=script&lang=js"

import "./BaseFnbSideNav.vue?vue&type=style&index=0&id=613821bd&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613821bd"]])

export default __exports__